import { Component, OnInit, ɵCodegenComponentFactoryResolver } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { fromLonLat, toLonLat } from 'ol/proj.js';
import { Tile as TileLayer, Vector, Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { Icon, Stroke, Style } from 'ol/style';
import OSM from 'ol/source/OSM';
import Overlay from 'ol/Overlay';
import { toStringHDMS } from 'ol/coordinate';
import { UserService } from 'src/app/services/user.service';
import { NotificationService } from 'src/app/services/notification.service ';
import { ActivatedRoute } from '@angular/router';
import XYZ from 'ol/source/XYZ';
import { async } from '@angular/core/testing';
var _ = require('lodash');


const key = '5KdkENFJupPxNvDavJA8';
const attributions =
  '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> ' +
  '<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>';
 
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  map;
  youtubeUrl = 'https://www.youtube.com/watch?v=WQFjZymnF3M';
  youtubeVideoId = 'WQFjZymnF3M';
  chicago;
  vectorSource;
  vectorLayer;
  rasterLayer;
  london: any;
  madrid: any;
  value = "";
  searchId = null;
  details = null;
  constructor(private userService: UserService, private route: ActivatedRoute,
    private notifyService: NotificationService,
  ) {
    if (this.route.snapshot.params.id) {
      this.searchId = this.route.snapshot.params.id;
      this.value = this.searchId;

    }
    else
      console.log("ok")

  }

  ngOnInit() {
    const tag = document.createElement('script');
    const container = document.getElementById('popup'); container.hidden = true;
    // this.userService.getUserMapMarks().subscribe(
    //   async value => {
    //     console.log(value);
    //     this.initilizeMap(value,null);
    //     // if(this.route.snapshot.params.id)
    //     // {
    //     //   this.onChange(this.route.snapshot.params.id,true);this.onChange(this.route.snapshot.params.id,false);
    //     // }

    //   },
    //   error1 => {

    //     console.log(error1);
    //   }
    // ); 
   
          this.notifyService.showSuccess("Bienvenue!", "TELEFRET")
         
          this.userService.isAuth = true;
          // alert(this.route.snapshot.params.id)
          if (this.route.snapshot.params.id) {
            this.onChange(this.route.snapshot.params.id, true); this.onChange(this.route.snapshot.params.id, false);
          }
       


  }

  initilizeMap(ListMarker, filter, direction) {
    const container = document.getElementById('popup');
    const content = document.getElementById('popup-content');
    const closer = document.getElementById('popup-closer');
    if(container)
    container.hidden = false;
    console.log("container", container);
    console.log("content", content);
    console.log("closer", closer);
    var arrayMarker = [];
    const divmap = document.getElementById('map');
    ListMarker.map(element => {
        if (filter && filter != '' && element.idRealTimeRecord) {
            divmap.innerHTML = '<label>Loading..</label>';
            this.valueFind = true;
            console.log("filterrrrr", (element.idRealTimeRecord + "").includes(filter));
            console.log("*******************************************", [element.coordinate.lng, element.coordinate.lat]);
            var feature = new Feature({
                type: 'click',
                geometry: new Point(fromLonLat([element.coordinate.lng, element.coordinate.lat]))
            });
            feature.setStyle(new Style({
                image: new Icon(({
                    scale: 0.7,
                    rotateWithView: false,
                    anchor: [0.5, 1],
                    opacity: 1,
                    src: '../../../../../assets/markeurnew_64x64.png'
                }))
            }));
            feature.addEventListener('click', event => {
                console.log(event);
                return true;
            });
            if (direction && direction.from && direction.to) {
                // var routeLayer = new Vector({
                //    style: new Style({
                //      stroke:new Stroke({ color: "hsl(205, 100%, 50%)", width: 4 })
                //    })
                //  });
                console.log("*******************************************", [parseFloat(direction.from.lat), parseFloat(direction.from.lat)]);
                console.log("*******************************************", [parseFloat(direction.from.lon), parseFloat(direction.from.lon)]);
                var feature1 = new Feature({
                    type: 'click',
                    geometry: new Point(fromLonLat([parseFloat(direction.from.lon), parseFloat(direction.from.lat)]))
                });
                feature1.setStyle(new Style({
                    image: new Icon(({
                        scale: 0.7,
                        rotateWithView: false,
                        anchor: [0.5, 1],
                        opacity: 1,
                        src: '../../../../../assets/dotgreen1.png'
                    }))
                }));
                feature1.addEventListener('click', event => {
                    console.log(event);
                    return true;
                });
                arrayMarker.push(feature1);
                var feature2 = new Feature({
                    type: 'click',
                    geometry: new Point(fromLonLat([parseFloat(direction.to.lon), parseFloat(direction.to.lat)]))
                });
                feature2.setStyle(new Style({
                    image: new Icon(({
                        scale: 0.7,
                        rotateWithView: false,
                        anchor: [0.5, 1],
                        opacity: 1,
                        src: '../../../../../assets/dotred1.png'
                    }))
                }));
                feature2.addEventListener('click', event => {
                    console.log(event);
                    return true;
                });
                arrayMarker.push(feature2);
            }
            arrayMarker.push(feature);
        }
        else if (filter == null || filter == '') {
            if (direction && direction.from && direction.to) {
                // var routeLayer = new Vector({
                //    style: new Style({
                //      stroke:new Stroke({ color: "hsl(205, 100%, 50%)", width: 4 })
                //    })
                //  });
                var feature1 = new Feature({
                    type: 'click',
                    geometry: new Point(fromLonLat([direction.from.lng, direction.from.lat]))
                });
                
                feature1.setStyle(new Style({
                    image: new Icon(({
                        scale: 0.7,
                        rotateWithView: false,
                        anchor: [0.5, 1],
                        opacity: 1,
                        src: '../../../../../assets/dotgreen.png'
                    }))
                }));
                feature1.addEventListener('click', event => {
                    console.log(event);
                    return true;
                });
                arrayMarker.push(feature1);
                var feature2 = new Feature({
                    type: 'click',
                    geometry: new Point(fromLonLat([direction.to.lng, direction.to.lat]))
                });
                feature2.setStyle(new Style({
                    image: new Icon(({
                        scale: 0.7,
                        rotateWithView: false,
                        anchor: [0.5, 1],
                        opacity: 1,
                        src: '../../../../../assets/dotred.png'
                    }))
                }));
                feature2.addEventListener('click', event => {
                    console.log(event);
                    return true;
                });
                arrayMarker.push(feature2);
            }
            arrayMarker.push(feature);
        }
    });
    // this.chicago = new Feature({
    //   geometry: new Point(fromLonLat([	-87.623177, 41.881832]))
    // });
    // this.chicago.setStyle(new Style({
    //   image: new Icon(({
    //     color: '#8959A8',
    //     crossOrigin: 'anonymous',
    //     src: 'assets/vectorpoint.svg',
    //     imgSize: [20, 20]
    //   }))
    // }));
    // arrayMarker.push(this.chicago)
    // this.london = new Feature({
    //   geometry: new Point(fromLonLat([-0.12755, 51.507222]))
    // });
    // this.madrid = new Feature({
    //   geometry: new Point(fromLonLat([-3.683333, 40.4]))
    // });
    // this.london.setStyle(new Style({
    //   image: new Icon(({
    //     color: '#4271AE',
    //     crossOrigin: 'anonymous',
    //     src: 'assets/vectorpoint.svg',
    //     imgSize: [20, 20]
    //   }))
    // }));
    // this.madrid.setStyle(new Style({
    //   image: new Icon(({
    //     color: [113, 140, 0],
    //     crossOrigin: 'anonymous',
    //     src: 'assets/dot.png',
    //     imgSize: [20, 20]
    //   }))
    // }));
    this.vectorSource =  new VectorSource({
        features: arrayMarker
    });
    this.vectorLayer = new VectorLayer({
        source: this.vectorSource
    });
    const overlay =new Overlay({
        element: container,
        autoPan: true,
        autoPanAnimation: {
            duration: 250
        }
    });
    divmap.innerHTML = null;
    this.map =new Map({
        target: 'map',
        layers: [new TileLayer({
          source: new OSM() as any
        }),
        this.vectorLayer],
       /** layers: [
          new TileLayer({
            source: new XYZ({
              attributions: attributions,
              url: 'https://api.maptiler.com/tiles/satellite/{z}/{x}/{y}.jpg?key=' + key,
              tileSize: 512,
            }),
          }),
          this.vectorLayer
        ],
         */
        overlays: [overlay],
        view: new View({
            center: fromLonLat([ListMarker[0].coordinate.lng, ListMarker[0].coordinate.lat]),
            zoom: 7
        })
    });
    var that = this;
    this.map.on('click', function (evt) {
        var f = that.map.forEachFeatureAtPixel(evt.pixel, function (ft, layer) { return ft; });
        if (f && f.get('type') == 'click') {
            var geometry = f.getGeometry();
            var coord = geometry.getCoordinates();
            const coordinate = coord;
            const hdms =toStringHDMS(toLonLat(coordinate));
            var value = that.userService.ListMarker.find(x => {
                return ((x.coordinate.lng + "").substr(0, 5) == (toLonLat(coordinate)[0] + "").substr(0, 5)) && ((x.coordinate.lat + "").substr(0, 5) == (toLonLat(coordinate)[1] + "").substr(0, 5));
            });
            console.log("***********************************1111", value);
            if (value) {
                var city;
                var speed = value.speed;
                var date = new Date(value.recordTime);
                var dateStr = ("00" + (date.getMonth() + 1)).slice(-2) + "/" +
                    ("00" + date.getDate()).slice(-2) + "/" +
                    date.getFullYear() + " " +
                    ("00" + date.getHours()).slice(-2) + ":" +
                    ("00" + date.getMinutes()).slice(-2) + ":" +
                    ("00" + date.getSeconds()).slice(-2);
                fetch('https://telefret.com/api_redirect/?lon=' +toLonLat(coordinate)[0] + '&lat=' +toLonLat(coordinate)[1])
                    .then(function (response) {
                    return response.json();
                }).then(function (json) {
                    city = json.display_name;
                    console.log("valuevaluevaluevaluevaluevaluevaluevalue", value);
                    content.innerHTML = `
                    <p> <b>Matricule:</b> ${value.Abonnement?.matricule}</p>
                    <p> <b>Conducteur:</b> ${value.Abonnement?.nom_chauffeur}
      
                    </p>
                    <p> <b>Téléphone:</b> ${value.Abonnement?.telephone_chauffeur}
      
                    </p>
       
          <p> <b>Date:</b> ${value.recordTime ? dateStr : "Inconnu"}
      
          </p>
          <p>
          <b>Vitesse: </b> ${speed}
            </p>
            <p> <b>Position:</b> ${city}
      
            </p>

            `;
                    overlay.setPosition(coordinate);
                });
            }
            else {
                var date = new Date();
                var dateStr = ("00" + (date.getMonth() + 1)).slice(-2) + "/" +
                    ("00" + date.getDate()).slice(-2) + "/" +
                    date.getFullYear() + " " +
                    ("00" + date.getHours()).slice(-2) + ":" +
                    ("00" + date.getMinutes()).slice(-2) + ":" +
                    ("00" + date.getSeconds()).slice(-2);
                fetch('https://telefret.com/api_redirect/?lon=' +toLonLat(coordinate)[0] + '&lat=' + toLonLat(coordinate)[1])
                    .then(function (response) {
                    return response.json();
                }).then(function (json) {
                    city = json.display_name;
                    content.innerHTML = `
            
        <p> <b> Adresse:</b> ${city}</p>
        <p> <b>Date:</b> ${dateStr}</p>
          `;
                    overlay.setPosition(coordinate);
                });
            }
        }
        else {
            closer.click();
        }
    });
    this.map.on('pointermove', function (e) {
        if (e.dragging) {
            return;
        }
        var pixel = that.map.getEventPixel(e.originalEvent);
        var hit = that.map.hasFeatureAtPixel(pixel);
        console.log(that.map.getTarget());
        // that.map. .cursor = hit ? 'pointer' : '';
    });
    // this.map.on('singleclick', function (evt: any) {
    //   const coordinate = evt.coordinate;
    //   const hdms = toStringHDMS(toLonLat(coordinate));
    //   content.innerHTML = '<p>Current coordinates are :</p><code>' + hdms +
    //     '</code>';
    //   overlay.setPosition(coordinate);
    // });
    //   const map1= this.map;
    //   map1.on('singleclick', function(e) {
    //     var feature = map1.forEachFeatureAtPixel(e.pixel, function(feature) {
    //     return feature;
    //     });
    //     if(feature && feature. n.marker) {
    //         feature.n.marker.label.message = "CLICKED!"; // Do something smarter here ...
    //     }
    // });
    closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
    };
}

  valueFind = false;
  directionTofind=null;

  requestAsync(val,toast) {
    var direction = { from: null, to: null };
    var that=this
    return new Promise((resolve, reject) => {
      if (val != "") {
 
    
        if (!toast) {
          that.initilizeMap(that.details, val, that.directionTofind);
  
        } else {
          
       
    
          that.userService.getUserMapMarks(val).subscribe(
            async value => {
              console.log("valuevaluevaluevaluevalue",value);
              that.details = value ? value : null;
   
    if (that.details) {
     await that.userService.getUserMapMarksVal("").subscribe(
        async listvalue => {
 
        that.details=await  ( that.details as []).map((e) => {
          let magenicVendor =          (  listvalue as [])
          .findIndex( vendor => true );
          console.log( (e as any).Abonnement.ID_gps,"valuevaluevaluevaluevalue",listvalue[magenicVendor],"val");
  
          if (magenicVendor>=0) {
            return {... (e as any),... listvalue[magenicVendor]};
          }
  
        return e;
       })
       console.log("valuevaluevaluevaluevalue",that.details);
  
  
        fetch('https://nominatim.openstreetmap.org/search?q=' + that.details[0].Chargement.adresse_charg + '+' + that.details[0].Chargement.ville_charg + '+' + that.details[0].Chargement.pays_charg + '&format=json&polygon=1&addressdetails=1')
          .then(function (response) {
            return response.json();
          }).then(function (json) {
            console.log(json)
            if (json && json.length > 0) {
              direction.from = json[0];
              fetch('https://nominatim.openstreetmap.org/search?q=' + that.details[0].Chargement.adresse_liv + '+' + that.details[0].Chargement.ville_liv + '+' + that.details[0].Chargement.pays_liv + '&format=json&polygon=1&addressdetails=1')
                .then(function (response) {
                  return response.json();
                }).then(function (json) {
                  console.log(json)
                  if (json && json.length > 0) {
                    direction.to = json[0];
                    var array = [];
                    array.push(value);
                    that.userService.ListMarker = that.details;
                    console.log("that.detailsthat.detailsthat.details",that.details)
                    that.directionTofind=direction;
                    that.initilizeMap(that.details, val, direction);
                    resolve({details:that.details, val, direction});

                  }
      
                  //overlay.setPosition(coordinate);
                });
      
            }
      
            //overlay.setPosition(coordinate);
          });
      },
      error1 => {
        if (toast)
          that.notifyService.showError(error1.error, "TELEFRET");
    
        console.log(error1);
      }
    );
      
    
        
          /**    that.userService.getUserMapMarksVal((that.details[0].Chargement.adresse_charg?( that.details[0].Chargement.adresse_charg ):"") +
               (that.details[0].Chargement.ville_charg?
               (  '+'+that.details[0].Chargement.ville_charg ):"" )+ (that.details[0].Chargement.pays_charg?('+'+ that.details[0].Chargement.pays_charg) :"")
               ).subscribe( (json)=> {
                    console.log(json)
                    if (json && (json as []).length > 0) {
                      direction.from = json[0];
                    that.userService.getUserMapMarksVal((that.details[0].Chargement.adresse_liv?( that.details[0].Chargement.adresse_liv ):"") +
                    (that.details[0].Chargement.ville_liv?
                    (  '+'+that.details[0].Chargement.ville_liv ):"" )+ (that.details[0].Chargement.pays_liv?('+'+ that.details[0].Chargement.pays_liv) :"")
                    ).subscribe( (json)=> {
                          console.log(json)
                          if (json && (json as []).length > 0) {
                            direction.to = json[0];
                            var array = [];
                            array.push(value);
                            that.userService.ListMarker = that.details;
                            that.initilizeMap(that.details, val, direction);
                          }
    
                          //overlay.setPosition(coordinate);
                        });
    
                    }
    
                    //overlay.setPosition(coordinate);
                  });
     */ 
    
              }
    
    
    
            },
            error1 => {
              if (toast)
                that.notifyService.showError(error1.error, "TELEFRET");
                reject(error1);

              console.log(error1);
            }
          );
        }
      } else if (toast)
        that.notifyService.showError("Veillez entrer une valeur!", "TELEFRET");
  
    });
}
onChange1(val, toast) {
  var that=this;
 this. requestAsync(val, toast).then(countryDetails => {
 // alert("ok")
  that.initilizeMap((countryDetails as any ).details,  (countryDetails as any ).val, (countryDetails as any ).directionTofind);

    console.log("countryDetailscountryDetailscountryDetailscountryDetailscountryDetails",countryDetails);
}).catch((err) => {
    console.log(err);  
}); 
}
  onChange(val, toast) {
    console.log(val)
    var direction = { from: null, to: null };
    var that=this
    if (val != "") {
 
    
      if (true) {
        
        
     
  
        that.userService.getUserMapMarks(val).subscribe(
          async value => {
            console.log("valuevaluevaluevaluevalue",value);
            that.details = value ? value : null;
  //that.details=JSON.parse('[{"idRealTimeRecord":821801,"recordTime":1656242196000,"coordinate":{"lng":14.363634999999999,"lat":4.43388},"speed":0,"fuel":0,"rpm":0,"fuel_rate":0,"tfu":0,"odo":0,"temp_engine":0,"accum_odo":0,"temperature":"32839","validity":true,"ignition":false,"type":"AA","power":42,"mems_x":-11,"mems_y":-9,"mems_z":21,"sendFlag":1,"satInView":14,"heading":0,"signal":"18","idDevice":821801,"matricule":null,"mark":null,"icon":null,"rotationAngle":11,"model":null,"di1":false,"di2":false,"lastRawTime":1656242201000,"realTimeRecordStatus":"VALID","Disponibilite":{"id_disp":"219","poid_disp":"30","pays_dep":"Cameroun","ville_dep":"","date_dep":"30\/06\/2022","adresse_dep":"Logbaba","pays_arr":"Cameroun","ville_arr":"","date_arr":"09\/07\/2022","adresse_arr":"ngousso","contact_name":"","contact_phone":"","id_abonnement":"28","id_chargement":"399"},"Chargement":{"id_charg":"399","marchandise":"Vehicules","emballage":"","mode_t":"","valeurm":" ","poid":"","nb_colis":"0","volume":"","type_vehicule":"","details_march":"","img_march":"","pays_charg":"Cameroun","ville_charg":"","date_charg":"30\/06\/2022","adresse_charg":"Logbaba","pays_liv":"Cameroun","ville_liv":"","date_liv":"09\/07\/2022","adresse_liv":"ngousso","tol_charg":"0","jr_retard2":"0","tol_liv":"0","jr_retard":"0","contact_name":"","contact_phone":"","telephone":"690465196","prix_prop":" ","nb_vehicules":"1","status":"1","avance":"0","methodepayement":"Esp\u00e8ce","autre_info":"","created_at":"2022-06-25 02:42:42"},"Abonnement":{"id_abonnement":"28","matricule":"LT052 KY","marque":"MERCEDES ACTROS 3042","date_deb":"16\/12\/2021","date_fin":"16\/06\/2022","gps":"1","telephone":"690465196","type_vehicule":"Plateau","poid_max":"30","img_vehicule":"16171219631.png","valide":"0","ID_gps":"821814","nom_chauffeur":"","telephone_chauffeur":"","cni":"","assurance":"","carte_grise":""},"Transporteur":{"nom":"tchiente","prenom":"yannick","r_s":"","pays":"Cameroun","adresse":"logpom, douala","telephone":"690465196","email":"yannicktchiente@gmail.com","password":"yane01","type":"transporteur","genre":"particulier","date_limite":"03\/04\/2021","note":"0","nb_note":"0","total_note":"0","verif":"1","code":"0211","indicatif":"00237","Date_inscri":""},"Chargeur":{"nom":"tchiente","prenom":"yannick","r_s":"","pays":"Cameroun","adresse":"logpom, douala","telephone":"690465196","email":"yannicktchiente@gmail.com","password":"yane01","type":"transporteur","genre":"particulier","date_limite":"03\/04\/2021","note":"0","nb_note":"0","total_note":"0","verif":"1","code":"0211","indicatif":"00237","Date_inscri":""}},{"idRealTimeRecord":821825,"recordTime":1655570139000,"coordinate":{"lng":9.749006666666666,"lat":4.035261666666667},"speed":0,"fuel":0,"rpm":0,"fuel_rate":0,"tfu":0,"odo":0,"temp_engine":0,"accum_odo":0,"temperature":"32768","validity":true,"ignition":false,"type":"AA","power":41,"mems_x":-3,"mems_y":1,"mems_z":-3,"sendFlag":1,"satInView":12,"heading":0,"signal":"31","idDevice":821825,"matricule":null,"mark":null,"icon":null,"rotationAngle":36,"model":null,"di1":false,"di2":false,"lastRawTime":1655570147000,"realTimeRecordStatus":"TECHNICAL_ISSUE","Disponibilite":{"id_disp":"220","poid_disp":"32","pays_dep":"Cameroun","ville_dep":"","date_dep":"30\/06\/2022","adresse_dep":"Logbaba","pays_arr":"Cameroun","ville_arr":"","date_arr":"09\/07\/2022","adresse_arr":"ngousso","contact_name":"","contact_phone":"","id_abonnement":"27","id_chargement":"399"},"Chargement":{"id_charg":"399","marchandise":"Vehicules","emballage":"","mode_t":"","valeurm":" ","poid":"","nb_colis":"0","volume":"","type_vehicule":"","details_march":"","img_march":"","pays_charg":"Cameroun","ville_charg":"","date_charg":"30\/06\/2022","adresse_charg":"Logbaba","pays_liv":"Cameroun","ville_liv":"","date_liv":"09\/07\/2022","adresse_liv":"ngousso","tol_charg":"0","jr_retard2":"0","tol_liv":"0","jr_retard":"0","contact_name":"","contact_phone":"","telephone":"690465196","prix_prop":" ","nb_vehicules":"1","status":"1","avance":"0","methodepayement":"Esp\u00e8ce","autre_info":"","created_at":"2022-06-25 02:42:42"},"Abonnement":{"id_abonnement":"27","matricule":"RC 400 MK 4","marque":"volvo","date_deb":"21\/03\/2021","date_fin":"21\/03\/2022","gps":"1","telephone":"690465196","type_vehicule":"Plateau","poid_max":"32","img_vehicule":"16147726451.jpg","valide":"1","ID_gps":"","nom_chauffeur":"","telephone_chauffeur":"","cni":"","assurance":"","carte_grise":""},"Transporteur":{"nom":"tchiente","prenom":"yannick","r_s":"","pays":"Cameroun","adresse":"logpom, douala","telephone":"690465196","email":"yannicktchiente@gmail.com","password":"yane01","type":"transporteur","genre":"particulier","date_limite":"03\/04\/2021","note":"0","nb_note":"0","total_note":"0","verif":"1","code":"0211","indicatif":"00237","Date_inscri":""},"Chargeur":{"nom":"tchiente","prenom":"yannick","r_s":"","pays":"Cameroun","adresse":"logpom, douala","telephone":"690465196","email":"yannicktchiente@gmail.com","password":"yane01","type":"transporteur","genre":"particulier","date_limite":"03\/04\/2021","note":"0","nb_note":"0","total_note":"0","verif":"1","code":"0211","indicatif":"00237","Date_inscri":""}}]');
        
 
  if (that.details) {
   await that.userService.getUserMapMarksVal("").subscribe(
      async res => {
  /**await   (  listvalue as []).forEach( async (element  )  => {
        if (element) {
             let magenicVendor =  (that.details as []).findIndex( vendor => (vendor as any).Abonnement.ID_gps ==(element as any).idDevice );
        console.log("magenicVendormagenicVendormagenicVendor",magenicVendor)
        if(magenicVendor){
        that.details[magenicVendor]={... that.details[magenicVendor],...(element as any)}
        that.userService.ListMarker = that.details;
        }

       
        }
     
        
      });
 */ 
      let listvalues=_.groupBy((res as any).result, loc => loc.ident)
      console.log("listvalues",listvalues)

let listvalue=[];


for (const [key, elt] of Object.entries(listvalues)) {
  console.log(`${key}: ${elt}`);
  listvalue.push({
    "idRealTimeRecord": elt[0]["ident"],
    "recordTime": 1660577964000,
    "coordinate": {
      "lng": elt[0]["position.longitude"],
      "lat":elt[0]["position.latitude"]
    },
    "speed": 0,
    "fuel": 0,
    "rpm": 0,
    "fuel_rate": 0,
    "tfu": 0,
    "odo": 0,
    "temp_engine": 0,
    "accum_odo": 0,
    "temperature": "0",
    "validity": true,
    "ignition": true,
    "type": "AA",
    "power": 0,
    "mems_x": 0,
    "mems_y": 0,
    "mems_z": 0,
    "sendFlag": 0,
    "satInView": 0,
    "heading": 0,
    "signal": "0",
    "idDevice":  elt[0]["ident"],
    "matricule": null,
    "mark": null,
    "icon": null,
    "rotationAngle": 6,
    "model": null,
    "di1": false,
    "di2": false,
    "lastRawTime": 1660577964000,
    "realTimeRecordStatus": "VALID"
  })

}

console.log("lodash",listvalue)
      that.details=await  ( that.details as []).map((e) => {
        let magenicVendor =          (  listvalue as [])
        .findIndex( vendor => (e as any).Abonnement.ID_gps ==(vendor as any).idDevice );
       // .findIndex( vendor => "9171350277"==(vendor as any).idDevice  );

        console.log( (e as any).Abonnement.ID_gps,"valuevaluevaluevaluevalue",listvalue[magenicVendor],"val");

        if (magenicVendor>=0) {
          return {... (e as any),... listvalue[magenicVendor]};
        }

      return e;
     })
     console.log("valuevaluevaluevaluevalue",that.details);


      fetch('https://nominatim.openstreetmap.org/search?q=' + that.details[0].Chargement.adresse_charg + '+' + that.details[0].Chargement.ville_charg + '+' + that.details[0].Chargement.pays_charg + '&format=json&polygon=1&addressdetails=1')
        .then(function (response) {
          return response.json();
        }).then(function (json) {
          console.log(json)
          if (json && json.length > 0) {
            direction.from = json[0];
            fetch('https://nominatim.openstreetmap.org/search?q=' + that.details[0].Chargement.adresse_liv + '+' + that.details[0].Chargement.ville_liv + '+' + that.details[0].Chargement.pays_liv + '&format=json&polygon=1&addressdetails=1')
              .then(function (response) {
                return response.json();
              }).then(function (json) {
                console.log(json)
                if (json && json.length > 0) {
                  direction.to = json[0];
                  var array = [];
                  array.push(value);
                  that.userService.ListMarker = that.details;
                  console.log("that.detailsthat.detailsthat.details",that.details)
                  that.directionTofind=direction;
                  that.initilizeMap(that.details, val, direction);
                }
    
                //overlay.setPosition(coordinate);
              });
    
          }
    
          //overlay.setPosition(coordinate);
        });
    },
    error1 => {
      if (toast)
        that.notifyService.showError(error1.error, "TELEFRET");
  
      console.log(error1);
    }
  );
    
  
      
        /**    that.userService.getUserMapMarksVal((that.details[0].Chargement.adresse_charg?( that.details[0].Chargement.adresse_charg ):"") +
             (that.details[0].Chargement.ville_charg?
             (  '+'+that.details[0].Chargement.ville_charg ):"" )+ (that.details[0].Chargement.pays_charg?('+'+ that.details[0].Chargement.pays_charg) :"")
             ).subscribe( (json)=> {
                  console.log(json)
                  if (json && (json as []).length > 0) {
                    direction.from = json[0];
                  that.userService.getUserMapMarksVal((that.details[0].Chargement.adresse_liv?( that.details[0].Chargement.adresse_liv ):"") +
                  (that.details[0].Chargement.ville_liv?
                  (  '+'+that.details[0].Chargement.ville_liv ):"" )+ (that.details[0].Chargement.pays_liv?('+'+ that.details[0].Chargement.pays_liv) :"")
                  ).subscribe( (json)=> {
                        console.log(json)
                        if (json && (json as []).length > 0) {
                          direction.to = json[0];
                          var array = [];
                          array.push(value);
                          that.userService.ListMarker = that.details;
                          that.initilizeMap(that.details, val, direction);
                        }
  
                        //overlay.setPosition(coordinate);
                      });
  
                  }
  
                  //overlay.setPosition(coordinate);
                });
   */ 
  
            }
  
  
  
          },
          error1 => {
            if (toast)
              that.notifyService.showError(error1.error, "TELEFRET");
  
            console.log(error1);
          }
        );
      }
    } else if (toast)
      that.notifyService.showError("Veillez entrer une valeur!", "TELEFRET");


  }
  onChangeValue(val) {
    this.value = val;
  }

  reverseGeocode(coords) {
    fetch('http://nominatim.openstreetmap.org/reverse?format=json&lon=' + coords[0] + '&lat=' + coords[1])
      .then(function (response) {
        return response.json();
      }).then(function (json) {
        console.log(json);
      });
  }

}
